import { defineStyle, defineSlotRecipe } from '@chakra-ui/react';

const baseStyleField = defineStyle({
  // Default appearance, often similar to an 'outline' variant
  backgroundColor: 'white',
  border: '1px solid',
  borderColor: 'border.secondary',
  borderRadius: 'md', // Using a theme token like 'md' (e.g., '8px')
  minHeight: 'controlHeight',
  py: '2',
  px: '3',
  color: 'text.primary',
  display: 'block',
  width: '100%',
  transitionProperty: 'common',
  transitionDuration: 'normal',

  _placeholder: {
    color: 'text.placeholder',
    opacity: 1,
  },
  _hover: {
    borderColor: 'border.tertiary',
  },
  _focusVisible: {
    borderColor: 'border.action',
    boxShadow: `0 0 0 1px var(--chakra-colors-border-action)`,
    zIndex: 1,
  },
  _disabled: {
    opacity: 0.6,
    cursor: 'not-allowed',
    borderColor: 'border.secondary',
    backgroundColor: 'surface.disabled',
  },
});

const manualSignInTopCornersField = defineStyle({
  borderTopRadius: 'sm',
  borderBottomRadius: '0',
});

const filledVariantField = defineStyle({
  ...baseStyleField, // Can start with base styles and override
  backgroundColor: 'surface.input', // Semantic token for filled background
  borderWidth: '1px', // Often, filled inputs might have a border on focus or be borderless initially
  borderColor: 'transparent', // Typically borderless until focus/hover
  _hover: {
    backgroundColor: 'surface.input', // Or a slightly different hover color from theme
    borderColor: 'border.secondary', // Show border on hover
  },
  _focusVisible: {
    backgroundColor: 'surface.input',
    borderColor: 'border.action', // Action color for focus
    boxShadow: `0 0 0 1px var(--chakra-colors-border-action)`,
  },
});

const baseStyleObject = {
  field: baseStyleField,
}

const outlineVariant = {
  field: baseStyleField,
}

const manualSignInTopCornersVariant = {
  field: manualSignInTopCornersField,
};

const filledVariant = {
  field: filledVariantField,
};


// Define the input theme configuration
export const inputRecipe = defineSlotRecipe({
  slots: [ "field", "addon", "element" ],
  base: baseStyleObject,
  variants: {
    visual: {
      'outline': outlineVariant,
      'filled': filledVariant,
      'manual-signin-top': manualSignInTopCornersVariant,
    },
    size: {
      sm: {
        field: {
          minHeight: 'controlHeightSm',
          py: '1',
          px: '2',
          fontSize: 'sm',
        },
      },
      md: {},
      lg: {
        field: {
          minHeight: 'controlHeightLg',
          py: '2.5',
          px: '4',
          fontSize: 'lg',
        },
      },
    },
  },
  defaultVariants: {
    visual: 'filled',
    size: 'md',
  },
});

// How to use the variant in your component:
//
// <Input
//   name={'email'}
//   type={'email'}
//   placeholder={'Email address'}
//   variant={manualSignIn ? 'manual-signin-top' : undefined} // Relies on defaultProps.variant if undefined
//   // ... other props
// />
